export default __webpack_public_path__ + "assets/32878323e1064f5dc78bedbf96f99f6c.jpg";